import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const LeftNavigationArrow: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      className={UNSAFE_className || ''}
      data-testid={`Left navigation arrow`}
      {...props}
      height={IconHeight[size]}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.96724 12.7898H20.373C20.5855 12.7898 20.7637 12.718 20.9075 12.5743C21.0512 12.4305 21.123 12.2522 21.123 12.0395C21.123 11.827 21.0512 11.649 20.9075 11.5053C20.7637 11.3618 20.5855 11.29 20.373 11.29H4.96724L9.30399 6.93803C9.44015 6.8012 9.5114 6.63012 9.51774 6.42478C9.5239 6.21945 9.45265 6.04187 9.30399 5.89203C9.16765 5.7547 8.99415 5.68604 8.78349 5.68604C8.57265 5.68604 8.39807 5.75529 8.25974 5.89379L2.74623 11.4073C2.65257 11.5008 2.58657 11.6 2.54823 11.7048C2.50974 11.8095 2.49049 11.9216 2.49049 12.0413C2.49049 12.161 2.50982 12.2746 2.54849 12.3823C2.58732 12.49 2.65323 12.59 2.74623 12.6823L8.25974 18.1958C8.39657 18.3341 8.56765 18.4033 8.77299 18.4033C8.97815 18.4033 9.15515 18.3341 9.30399 18.1958C9.45899 18.047 9.5349 17.8687 9.53174 17.661C9.52857 17.4534 9.45265 17.2752 9.30399 17.1265L4.96724 12.7898Z"
        fill="#1F1F1F"
      />
    </svg>
  );
};

export default LeftNavigationArrow;
